"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcBillingList = class UcBillingList extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getQueryParameters(...args) {
        return {
            company_id: this.companyId,
            client_id: this.clientId,
            rental_id: this.rentalId,
            contract_id: this.contractId,
        };
    }
    onCreateInvoicesPayload(...args) {
        return {
            items: this.selectedItems.map(p => ({ id: p.id }))
        };
        return this.$imodal
            .show({ name: 'CompleteInvoicesAlt' })
            .then(result => {
            if (!result || result.cancel || !result.value) {
                return;
            }
            return this.selectedItems.map(p => ({
                ...result.value,
                invoice_id: p.id,
            }));
        });
    }
    onCreateBillingPlan(...args) {
        return {
            items: this.selectedItems.map(p => ({ id: p.id }))
        };
        return this.$imodal
            .show({ name: 'CreateBillingPlan' })
            .then(result => {
            if (!result || result.cancel || !result.value) {
                return;
            }
            return this.selectedItems.map(p => ({
                ...result.value,
                invoice_id: p.id,
            }));
        });
    }
    getDownloadViewsPayload(...args) {
        return {
            identities: _.chain(this.selectedItems)
                .filter(p => p.invoice && p.invoice.id)
                .map(p => p.invoice.id)
                .uniq()
                .value()
        };
    }
    boundDownloadViewsPayloadMethod(...args) {
        if (!this._getDownloadViewsPayload) {
            this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
        }
        return this._getDownloadViewsPayload;
    }
    companyId;
    onCompany_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("companyId");
    }
    clientId;
    onClient_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("clientId");
    }
    rentalId;
    onRental_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("rentalId");
    }
    contractId;
    onContract_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contractId");
    }
    gridName;
    messages;
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_billing_list_item', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_columnDefaults;
    b_7315092382398562_columns;
    dataMembers = ['gridName', 'messages', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_columnDefaults', 'b_7315092382398562_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                gridName: "billingList",
                messages: {
                    title: this.$fn.pgettext("billingList|Title", "Billing list"),
                    exportFilename: this.$fn.pgettext("billingList|Export|Filename", "billing-list"),
                },
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_7315092382398562_columns: [{
                        field: "invoice_date",
                        name: this.$fn.pgettext("BillingList", "Billing due date"),
                        type: "date",
                    },
                    {
                        field: "invoice",
                        name: this.$fn.pgettext("BillingList", "Invoice"),
                        params: {
                            sortPath: "invoice.invoice_number",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                            ],
                        },
                    },
                    {
                        field: "due_date",
                        name: this.$fn.pgettext("BillingList", "Payment due date"),
                        type: "date",
                    },
                    {
                        name: this.$fn.pgettext("BillingList", "Period start"),
                        params: {
                            sortPath: "period.start",
                        },
                        field: "period.start",
                        type: "date",
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "period.start",
                                },
                            },
                        ],
                    },
                    {
                        name: this.$fn.pgettext("BillingList", "Period end"),
                        params: {
                            sortPath: "period.end",
                        },
                        field: "period.end",
                        type: "date",
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "period.end",
                                },
                            },
                        ],
                    },
                    {
                        field: "company",
                        name: this.$fn.pgettext("BillingList", "Company"),
                        width: "100px",
                        params: {
                            sortPath: "company.code",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "company.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "partner",
                        name: this.$fn.pgettext("BillingList", "Partner"),
                        width: "100px",
                        params: {
                            sortPath: "partner.code",
                        },
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "partner.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "contract",
                        name: this.$fn.pgettext("BillingList", "Contract"),
                        params: {
                            sortPath: "contract.contract_number",
                        },
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.contract_number }}\">{{ $value.contract_number }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "contract",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "contract.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "rental",
                        name: this.$fn.pgettext("BillingList", "Rental"),
                        params: {
                            sortPath: "rental.name",
                        },
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.name }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "rental.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("BillingList", "Description"),
                        type: "command",
                    },
                    {
                        field: "billing_category",
                        name: this.$fn.pgettext("BillingList", "Billing category"),
                    },
                    {
                        field: "notes",
                        name: this.$fn.pgettext("BillingList", "Notes"),
                    },
                    {
                        field: "quantity",
                        name: this.$fn.pgettext("BillingList", "Quantity"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "unit",
                        name: this.$fn.pgettext("BillingList", "Unit"),
                    },
                    {
                        field: "unit_price",
                        name: this.$fn.pgettext("BillingList", "Price"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "currency",
                        name: this.$fn.pgettext("BillingList", "Currency"),
                    },
                    {
                        field: "discount",
                        name: this.$fn.pgettext("BillingList", "Discount"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "net_amount",
                        name: this.$fn.pgettext("BillingList", "Net"),
                        type: "number",
                        formatter: "number",
                    },
                    {
                        field: "tax_code",
                        name: this.$fn.pgettext("BillingList", "Tax code"),
                    },
                    {
                        field: "exchange_rate",
                        name: this.$fn.pgettext("BillingList", "Exchrate"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    <span title=\"{{ $value.value }}\">{{ $value.value }}</span>\n\
\n\
    {{~#if $value.date }}\n\
      <span>&middot; {{ $value.date }}</span>\n\
    {{~/if }}\n\
\n\
    {{~#if $value.source }}\n\
      <span>&middot; {{ $value.source }}</span>\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                            ],
                        },
                    },
                    {
                        field: "intermediated_service",
                        name: this.$fn.pgettext("BillingList", "Intermediated Service"),
                        formatter: "checkmark",
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    async act_7315092382398562_setData_2210_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7315092382398562_selectedRowsChanged(event, scope) {
        return await this.actions.evh_7315092382398562_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_7315092382398562_showModal_2212_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.invoice.id,
                modal: true,
            },
        };
    }
    async evh_7315092382398562_command_2211_getWhen($event) {
        return $event.data.column.id === 'invoice';
    }
    async act_7315092382398562_reloadSlickgrid_2216_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_7315092382398562_close_2215_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_7315092382398562_showModal_2214_getActionArgs($event) {
        return {
            name: "BillingListItem",
            props: {
                oid: $event.data.data.id,
            },
        };
    }
    async evh_7315092382398562_command_2213_getWhen($event) {
        return $event.data.column.id === 'description';
    }
    async evh_7315092382398562_command(event, scope) {
        return await this.actions.evh_7315092382398562_command.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_reloadSlickgrid_2220_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_8320016629450276_close_2219_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_8320016629450276_showModal_2218_getActionArgs($event) {
        return {
            name: "CreateBillingPlan",
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    async act_6705964765214521_reloadSlickgrid_2224_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_6705964765214521_close_2223_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_6705964765214521_showModal_2222_getActionArgs($event) {
        return {
            name: "BillingListItem",
        };
    }
    async evh_6705964765214521_click(event, scope) {
        return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
    }
    async act_6806515264385235_reloadSlickgrid_2228_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_6806515264385235_close_2227_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_6806515264385235_showModal_2226_getActionArgs($event) {
        return {
            name: "CopyBillingListItems",
            props: {
                sources: _.map(this.selectedItems, 'id'),
            },
        };
    }
    async evh_6806515264385235_click(event, scope) {
        return await this.actions.evh_6806515264385235_click.executeFromDOM(this, event, scope);
    }
    async act_8116269939469002_reloadSlickgrid_2232_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_8116269939469002_request_2230_getActionArgs($event) {
        return {
            operation: "delete_many_billing_list_item",
            data: { items: this.selectedItems.map(p => p.id) },
        };
    }
    async evh_8116269939469002_click(event, scope) {
        return await this.actions.evh_8116269939469002_click.executeFromDOM(this, event, scope);
    }
    async act_5900129514656303_reloadSlickgrid_2236_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_5900129514656303_close_2235_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_5900129514656303_showModal_2234_getActionArgs($event) {
        return {
            name: "BatchBillingListEditor",
            props: {
                items: this.selectedItems,
            },
        };
    }
    async evh_5900129514656303_click(event, scope) {
        return await this.actions.evh_5900129514656303_click.executeFromDOM(this, event, scope);
    }
    async act_1655522927138420_reloadSlickgrid_2240_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_1655522927138420_close_2239_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_1655522927138420_showModal_2238_getActionArgs($event) {
        return {
            name: "UploadBillingListItems",
        };
    }
    async evh_1655522927138420_click(event, scope) {
        return await this.actions.evh_1655522927138420_click.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_reloadSlickgrid_2242_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_3343864469950044_success(event, scope) {
        return await this.actions.evh_3343864469950044_success.executeFromDOM(this, event, scope);
    }
    async act_1889980785424776_reloadSlickgrid_2246_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_1889980785424776_request_2244_getActionArgs($event) {
        return {
            operation: "merge_invoices",
            data: {
                items: _.chain(this.selectedItems)
                    .filter(p => _.get(p, 'invoice.id') != null)
                    .map(p => p.invoice.id)
                    .uniq()
                    .value()
            },
        };
    }
    async evh_1889980785424776_click(event, scope) {
        return await this.actions.evh_1889980785424776_click.executeFromDOM(this, event, scope);
    }
    async act_4892266742011185_reloadSlickgrid_2250_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_4892266742011185_request_2248_getActionArgs($event) {
        return {
            operation: "delete_draft_invoices",
            data: {
                invoices: _.chain(this.selectedItems)
                    .filter(p => _.get(p, 'invoice.id') != null)
                    .map(p => p.invoice.id)
                    .uniq()
                    .value()
            },
        };
    }
    async evh_4892266742011185_click(event, scope) {
        return await this.actions.evh_4892266742011185_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_setData_2210 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7315092382398562_setData_2210_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_selectedRowsChanged_2209 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_setData_2210,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_7315092382398562_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_selectedRowsChanged_2209],
        });
        const act_7315092382398562_showModal_2212 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7315092382398562_showModal_2212_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_command_2211 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_showModal_2212,
            event: "command",
            when: this.evh_7315092382398562_command_2211_getWhen,
            displayName: "showModal",
        });
        const act_7315092382398562_reloadSlickgrid_2216 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_7315092382398562_reloadSlickgrid_2216_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2215 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadSlickgrid_2216,
            event: "close",
            when: this.evh_7315092382398562_close_2215_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_7315092382398562_showModal_2214 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7315092382398562_showModal_2214_getActionArgs,
            events: [evh_7315092382398562_close_2215],
        });
        const evh_7315092382398562_command_2213 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_showModal_2214,
            event: "command",
            when: this.evh_7315092382398562_command_2213_getWhen,
            displayName: "showModal",
        });
        const evh_7315092382398562_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_command_2211, evh_7315092382398562_command_2213],
        });
        const act_8320016629450276_reloadSlickgrid_2220 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8320016629450276_reloadSlickgrid_2220_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_close_2219 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadSlickgrid_2220,
            event: "close",
            when: this.evh_8320016629450276_close_2219_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_8320016629450276_showModal_2218 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_2218_getActionArgs,
            events: [evh_8320016629450276_close_2219],
        });
        const evh_8320016629450276_click_2217 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_2218,
            event: "click",
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_2217],
        });
        const act_6705964765214521_reloadSlickgrid_2224 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6705964765214521_reloadSlickgrid_2224_getActionArgs,
            events: [],
        });
        const evh_6705964765214521_close_2223 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_reloadSlickgrid_2224,
            event: "close",
            when: this.evh_6705964765214521_close_2223_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_6705964765214521_showModal_2222 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6705964765214521_showModal_2222_getActionArgs,
            events: [evh_6705964765214521_close_2223],
        });
        const evh_6705964765214521_click_2221 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_showModal_2222,
            event: "click",
            displayName: "showModal",
        });
        const evh_6705964765214521_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_click_2221],
        });
        const act_6806515264385235_reloadSlickgrid_2228 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6806515264385235_reloadSlickgrid_2228_getActionArgs,
            events: [],
        });
        const evh_6806515264385235_close_2227 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_reloadSlickgrid_2228,
            event: "close",
            when: this.evh_6806515264385235_close_2227_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_6806515264385235_showModal_2226 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6806515264385235_showModal_2226_getActionArgs,
            events: [evh_6806515264385235_close_2227],
        });
        const evh_6806515264385235_click_2225 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_showModal_2226,
            event: "click",
            displayName: "showModal",
        });
        const evh_6806515264385235_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6806515264385235_click_2225],
        });
        const act_8116269939469002_reloadSlickgrid_2232 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8116269939469002_reloadSlickgrid_2232_getActionArgs,
            events: [],
        });
        const evh_8116269939469002_success_2231 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_reloadSlickgrid_2232,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_8116269939469002_request_2230 = new core_1.actions.RequestAction({
            actionArgs: this.act_8116269939469002_request_2230_getActionArgs,
            displayName: "deleteItems",
            events: [evh_8116269939469002_success_2231],
        });
        const evh_8116269939469002_click_2229 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_request_2230,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_8116269939469002_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8116269939469002_click_2229],
        });
        const act_5900129514656303_reloadSlickgrid_2236 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_5900129514656303_reloadSlickgrid_2236_getActionArgs,
            events: [],
        });
        const evh_5900129514656303_close_2235 = new core_1.actions.EventHandlerImpl({
            action: act_5900129514656303_reloadSlickgrid_2236,
            event: "close",
            when: this.evh_5900129514656303_close_2235_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_5900129514656303_showModal_2234 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5900129514656303_showModal_2234_getActionArgs,
            events: [evh_5900129514656303_close_2235],
        });
        const evh_5900129514656303_click_2233 = new core_1.actions.EventHandlerImpl({
            action: act_5900129514656303_showModal_2234,
            event: "click",
            displayName: "showModal",
        });
        const evh_5900129514656303_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5900129514656303_click_2233],
        });
        const act_1655522927138420_reloadSlickgrid_2240 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1655522927138420_reloadSlickgrid_2240_getActionArgs,
            events: [],
        });
        const evh_1655522927138420_close_2239 = new core_1.actions.EventHandlerImpl({
            action: act_1655522927138420_reloadSlickgrid_2240,
            event: "close",
            when: this.evh_1655522927138420_close_2239_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_1655522927138420_showModal_2238 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1655522927138420_showModal_2238_getActionArgs,
            events: [evh_1655522927138420_close_2239],
        });
        const evh_1655522927138420_click_2237 = new core_1.actions.EventHandlerImpl({
            action: act_1655522927138420_showModal_2238,
            event: "click",
            displayName: "showModal",
        });
        const evh_1655522927138420_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1655522927138420_click_2237],
        });
        const act_3343864469950044_reloadSlickgrid_2242 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_3343864469950044_reloadSlickgrid_2242_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_success_2241 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_reloadSlickgrid_2242,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const evh_3343864469950044_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_success_2241],
        });
        const act_1889980785424776_reloadSlickgrid_2246 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1889980785424776_reloadSlickgrid_2246_getActionArgs,
            events: [],
        });
        const evh_1889980785424776_success_2245 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_reloadSlickgrid_2246,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1889980785424776_request_2244 = new core_1.actions.RequestAction({
            actionArgs: this.act_1889980785424776_request_2244_getActionArgs,
            displayName: "mergeInvoices",
            events: [evh_1889980785424776_success_2245],
        });
        const evh_1889980785424776_click_2243 = new core_1.actions.EventHandlerImpl({
            action: act_1889980785424776_request_2244,
            event: "click",
            displayName: "mergeInvoices",
        });
        const evh_1889980785424776_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1889980785424776_click_2243],
        });
        const act_4892266742011185_reloadSlickgrid_2250 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4892266742011185_reloadSlickgrid_2250_getActionArgs,
            events: [],
        });
        const evh_4892266742011185_success_2249 = new core_1.actions.EventHandlerImpl({
            action: act_4892266742011185_reloadSlickgrid_2250,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_4892266742011185_request_2248 = new core_1.actions.RequestAction({
            actionArgs: this.act_4892266742011185_request_2248_getActionArgs,
            displayName: "deleteInvoices",
            events: [evh_4892266742011185_success_2249],
        });
        const evh_4892266742011185_click_2247 = new core_1.actions.EventHandlerImpl({
            action: act_4892266742011185_request_2248,
            event: "click",
            displayName: "deleteInvoices",
        });
        const evh_4892266742011185_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4892266742011185_click_2247],
        });
        return {
            act_7315092382398562_setData_2210,
            evh_7315092382398562_selectedRowsChanged_2209,
            evh_7315092382398562_selectedRowsChanged,
            act_7315092382398562_showModal_2212,
            evh_7315092382398562_command_2211,
            act_7315092382398562_reloadSlickgrid_2216,
            evh_7315092382398562_close_2215,
            act_7315092382398562_showModal_2214,
            evh_7315092382398562_command_2213,
            evh_7315092382398562_command,
            act_8320016629450276_reloadSlickgrid_2220,
            evh_8320016629450276_close_2219,
            act_8320016629450276_showModal_2218,
            evh_8320016629450276_click_2217,
            evh_8320016629450276_click,
            act_6705964765214521_reloadSlickgrid_2224,
            evh_6705964765214521_close_2223,
            act_6705964765214521_showModal_2222,
            evh_6705964765214521_click_2221,
            evh_6705964765214521_click,
            act_6806515264385235_reloadSlickgrid_2228,
            evh_6806515264385235_close_2227,
            act_6806515264385235_showModal_2226,
            evh_6806515264385235_click_2225,
            evh_6806515264385235_click,
            act_8116269939469002_reloadSlickgrid_2232,
            evh_8116269939469002_success_2231,
            act_8116269939469002_request_2230,
            evh_8116269939469002_click_2229,
            evh_8116269939469002_click,
            act_5900129514656303_reloadSlickgrid_2236,
            evh_5900129514656303_close_2235,
            act_5900129514656303_showModal_2234,
            evh_5900129514656303_click_2233,
            evh_5900129514656303_click,
            act_1655522927138420_reloadSlickgrid_2240,
            evh_1655522927138420_close_2239,
            act_1655522927138420_showModal_2238,
            evh_1655522927138420_click_2237,
            evh_1655522927138420_click,
            act_3343864469950044_reloadSlickgrid_2242,
            evh_3343864469950044_success_2241,
            evh_3343864469950044_success,
            act_1889980785424776_reloadSlickgrid_2246,
            evh_1889980785424776_success_2245,
            act_1889980785424776_request_2244,
            evh_1889980785424776_click_2243,
            evh_1889980785424776_click,
            act_4892266742011185_reloadSlickgrid_2250,
            evh_4892266742011185_success_2249,
            act_4892266742011185_request_2248,
            evh_4892266742011185_click_2247,
            evh_4892266742011185_click,
            deleteItems: act_8116269939469002_request_2230,
            mergeInvoices: act_1889980785424776_request_2244,
            deleteInvoices: act_4892266742011185_request_2248,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcBillingList.prototype, "companyId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('companyId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcBillingList.prototype, "onCompany_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcBillingList.prototype, "clientId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('clientId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcBillingList.prototype, "onClient_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcBillingList.prototype, "rentalId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rentalId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcBillingList.prototype, "onRental_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcBillingList.prototype, "contractId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contractId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcBillingList.prototype, "onContract_id", null);
UcBillingList = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcBillingList);
exports.default = UcBillingList;
vue_property_decorator_1.Vue.component("UcBillingList", UcBillingList);
